import { CAARepository } from '../repositories/CAARepository'

export function ListWeekCAAReport(caaRepositoryAdapter: CAARepository) {
  return async function ({
    patientId,
    date
  }: {
    patientId: string
    date: string
  }) {
    return await caaRepositoryAdapter.listWeekCAAReport(patientId, date)
  }
}
